import userApi from "../../services/user.api";
import { UnverifiedUser } from "@/types/unverified-user.definition";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  fetchUnverifiedUsersFailure,
  fetchUnverifiedUsersRequest,
  fetchUnverifiedUsersSuccess,
  verifyUserFailure,
  verifyUserRequest,
  verifyUserSuccess,
} from "../reducers/unverifiedUsersSlice";

function* fetchUnverifiedUsersSaga() {
  try {
    const users: UnverifiedUser[] = yield call(userApi.getUnverifiedUsers);
    yield put(fetchUnverifiedUsersSuccess(users));
  } catch (error) {
    yield put(
      fetchUnverifiedUsersFailure(
        error instanceof Error
          ? error.message
          : "Failed to fetch unverified users"
      )
    );
  }
}

function* verifyUserSaga(action: {
  payload: { userId: number };
  type: string;
}) {
  try {
    yield call(userApi.verifyUser, action.payload.userId);
    yield put(verifyUserSuccess(action.payload.userId));
  } catch (error) {
    yield put(
      verifyUserFailure(
        error instanceof Error ? error.message : "Failed to verify user"
      )
    );
  }
}

export function* unverifiedUsersSaga() {
  yield takeLatest(fetchUnverifiedUsersRequest, fetchUnverifiedUsersSaga);
  yield takeEvery(verifyUserRequest, verifyUserSaga);
}
